import { createApp } from 'vue'
import App from '@/app/bootstrap/App.vue'
import router from '@/app/routes/routes'

createApp(App).use(router).mount('#app')
